import { useEffect, useState } from "react";
import { Alert, Button, Container, OffcanvasBody, OffcanvasHeader } from "reactstrap";
import { useNavigate } from "react-router-dom";
import styles from "./style.module.scss"
import DefaultOffCanvas from "../DefaultOffCanvas";
import { OpenUpgradePlanPubSub, OpenUpgradePlanPubSubPayload } from "@utils/pubsubs/PubSub";

const TENANT_MANAGE_URL = "/user/tenant-manage";

const UpgradePlanOffCanvas = () => {
    const navigate = useNavigate();
    const [isOpen, setOpen] = useState(false);
    const [featureLabel, setFeatureLabel] = useState<string | undefined>(undefined);
    const [featureId, setFeatureId] = useState<string | undefined>(undefined);

    useEffect(() => {
        const unsubscribe = OpenUpgradePlanPubSub.subscribe(openOffCanvas);
        return () => {
            unsubscribe();
        };
    }, []);

    const openOffCanvas = (payload: OpenUpgradePlanPubSubPayload) => {
        setFeatureLabel(payload.featureLabel);
        setFeatureId(payload.featureId);
        setOpen(true);
    }

    const onCanvasClosed = () => {
        setOpen(false);
    }

    const goToManageSuscription = () => {
        setOpen(false);
        const target = featureId
            ? `${TENANT_MANAGE_URL}?feature=${encodeURIComponent(featureId)}`
            : TENANT_MANAGE_URL;
        navigate(target);
    }

    return (
        <DefaultOffCanvas
            className={styles.offCanvas}
            direction="end"
            isOpen={isOpen}
            onClosed={onCanvasClosed}
            toggle={() => setOpen(!isOpen)}
        >
            <OffcanvasHeader className={styles.offCanvasHeader} toggle={onCanvasClosed}>
                Actualiza tu plan
            </OffcanvasHeader>
            <OffcanvasBody>
                <Container>
                    <Alert className="mb-4" color="warning">
                        {featureLabel
                            ? `La función "${featureLabel}" no está incluida en tu plan actual.`
                            : "Esta función no está incluida en tu plan actual."}
                    </Alert>
                    <p>
                        Actualiza tu tipo de suscripción para tener acceso a esta función y a más
                        características del sistema.
                    </p>
                    <div className={styles.actions}>
                        <Button color="primary" type="button" onClick={goToManageSuscription}>
                            Administrar mi suscripción
                        </Button>
                        <Button color="secondary" type="button" outline onClick={onCanvasClosed}>
                            Cerrar
                        </Button>
                    </div>
                </Container>
            </OffcanvasBody>
        </DefaultOffCanvas>
    );
}

export default UpgradePlanOffCanvas;
